import axios from 'axios'
import router from '../../router'
import store from '../../store'
import { Message } from 'element-ui'

export default {
  isAuthRedirect: false,
  request(params) {
    return new Promise((resolve, reject) => {
      let config = {}

      if (params.method == 'get') {
        config = {
          url: params.url,
          method: 'get',
          data: params.data || {},
        }
      } else {
        config = {
          url: params.url,
          method: 'post',
          data: params.data || {},
        }
      }

      axios(config)
        .then((res) => {
          resolve(res.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  requestAuth(params) {
    let token = localStorage.getItem('jyb_token')
    let headers = params.headers ? params.headers : {}
    headers['Authorization'] = 'Bearer ' + token
    headers['Access-credentials'] = 'sign'

    return new Promise((resolve, reject) => {
      let config = {}

      if (params.method == 'get') {
        config = {
          url: params.url,
          method: 'get',
          params: params.data || {},
          headers,
        }
      } else if (params.method == 'post') {
        config = {
          url: params.url,
          method: 'post',
          data: params.data || {},
          headers,
        }
      } else if (params.method == 'delete') {
        config = {
          url: params.url,
          method: 'delete',
          data: params.data || {},
          headers,
        }
      }
      else if (params.method == 'put') {
        config = {
          url: params.url,
          method: 'put',
          data: params.data || {},
          headers,
        }
      }
      axios(config)
        .then((res) => {
          this.isAuthRedirect = false
          resolve(res.data)
        })
        .catch((err) => {
          if (err?.response?.data && err?.response?.data?.status_code == 402) {
            if (!this.isAuthRedirect) {
              this.isAuthRedirect = true
              store.commit('cleatLogInfo', 'logout, clear.....')
              router.replace({
                path: '/login',
              })
            }
          } else {
            Message.error('网络或服务器异常！请重试！')
            this.isAuthRedirect = false
            reject(err)
          }
        })
    })
  },
}
